// Turn this off to restore the regular catalog without deleting the theme.
// The date check also keeps the theme limited to October.
export const HALLOWEEN_THEME_ENABLED = true;

export function isHalloweenThemeActive(date = new Date()) {
  return HALLOWEEN_THEME_ENABLED && date.getMonth() === 9;
}
